const NAME = "MY_REQUESTS_PAGE";

export default NAME;
